import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PingService {
  baseUrl = '/doc/';
  private http = inject(HttpClient);

  getBroadcastVPNStatus(): Observable<string> {
    return this.http.get(`${environment.baseUrl}${this.baseUrl}v1/ping`, { responseType: 'text' });
  }
}
